import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot,CanDeactivate, RouterStateSnapshot } from '@angular/router';

import { Observable, of } from 'rxjs';
import { LoginViewComponent } from 'src/Components/login-view/login-view.component';

@Injectable()
export class LoginGuardService implements CanDeactivate<LoginViewComponent> 
{
    component: Object;
    route: ActivatedRouteSnapshot;
 
   constructor(){
   }
 
   canDeactivate(component:LoginViewComponent,
                route: ActivatedRouteSnapshot, 
                state: RouterStateSnapshot,
                nextState: RouterStateSnapshot) : Observable<boolean> | Promise<boolean> | boolean {
        
if (localStorage.getItem('token') !== null) {
  return of(true);
  // if (next.url.length === 0) { // This needs to be checked why
  //   return of(true);
  // }
  //  else if (next.data.accessPoint !== undefined) {
  //   return this.authService.authorizeRequest(next.data).pipe(map(result => {
  //     if (result) {
  //       return true;
  //     } else {
  //       this.router.navigate(['/un-authorized']);
  //       return false;
  //     }
  //   }));
  // }
}  
else{
  return of(false);
}
  }
}
